import React from "react";
import PropTypes from "prop-types";
import { NumericTextBoxComponent } from "@syncfusion/ej2-react-inputs";
import classNames from "classnames";

/**
 * PercentageInput — Syncfusion NumericTextBoxComponent wrapper for percentage fields.
 *
 * Displays a numeric input with a `%` suffix, constrained between 0–100 by default.
 * Replaces react-number-format `NumericFormat` with `suffix=" %"`.
 *
 * @example
 * <PercentageInput placeholder="Ownership %" value={field.value} onChange={field.onChange} />
 */
export default function PercentageInput({
  placeholder,
  value,
  onChange,
  error,
  min = 0,
  max = 100,
  step = 1,
  decimals = 2,
  disabled = false,
  className,
  floatLabelType = "Auto",
  ...props
}) {
  return (
    <div className={classNames("percentage-input-wrapper", className)}>
      <NumericTextBoxComponent
        placeholder={placeholder}
        floatLabelType={floatLabelType}
        value={value ?? null}
        change={e => onChange?.(e.value)}
        min={min}
        max={max}
        step={step}
        decimals={decimals}
        format="###.## '%'"
        validateDecimalOnType
        enabled={!disabled}
        cssClass={classNames("e-outline", { "e-error": !!error })}
        {...props}
      />
      {error && <p className="mt-1 text-sm text-red-600">{error}</p>}
    </div>
  );
}

PercentageInput.propTypes = {
  placeholder: PropTypes.string,
  value: PropTypes.number,
  onChange: PropTypes.func,
  error: PropTypes.string,
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  decimals: PropTypes.number,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  floatLabelType: PropTypes.oneOf(["Auto", "Always", "Never"]),
};

